export const movies = [
  {
    id: "m1",
    title: "星际迷航者",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20lone%20astronaut%20standing%20before%20a%20giant%20glowing%20ringed%20planet%2C%20dramatic%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-01&orientation=portrait",
    year: 2024,
    genres: ["科幻", "冒险", "动作"],
    region: "美国",
    rating: 8.7,
    duration: "138分钟",
    director: "克里斯·诺兰",
    actors: ["艾登·科尔", "玛丽亚·洛佩兹", "周牧之"],
    synopsis: "在不远的未来，人类文明的最后一批探索者踏上寻找宜居星球的旅程。当飞船信号中断、补给告急时，领航员林澈必须在信任与生存之间做出抉择。影片以浩瀚宇宙为背景，探讨孤独、希望与人类延续的意义。",
    tags: ["太空", "科幻", "冒险"],
    hot: 98,
  },
  {
    id: "m2",
    title: "暗夜追凶",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20silhouetted%20detective%20in%20a%20rainy%20neon%20alley%20at%20night%2C%20dramatic%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-02&orientation=portrait",
    year: 2023,
    genres: ["犯罪", "悬疑", "惊悚"],
    region: "中国香港",
    rating: 8.2,
    duration: "124分钟",
    director: "陈守正",
    actors: ["梁家辉", "何韵诗", "赵文卓"],
    synopsis: "一宗尘封十年的连环失踪案再度浮出水面。老刑警程远在退休前最后一晚，循着一条微弱的线索踏入城市最阴暗的角落。真相与谎言交错，他必须在黎明到来之前找到那个隐藏在人群中的凶手。",
    tags: ["警匪", "悬疑", "犯罪"],
    hot: 91,
  },
  {
    id: "m3",
    title: "长安夜行",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20an%20ancient%20chinese%20warrior%20in%20flowing%20robes%20holding%20a%20sword%20under%20moonlight%2C%20dramatic%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-03&orientation=portrait",
    year: 2024,
    genres: ["古装", "动作", "历史"],
    region: "中国大陆",
    rating: 8.5,
    duration: "146分钟",
    director: "张承安",
    actors: ["吴亦风", "李芷若", "王靖"],
    synopsis: "盛唐长安，灯火通明之下暗流涌动。一名身手不凡的夜巡护卫卷入权臣争斗，为护住一份关乎百姓安危的名册，孤身对抗整座城的黑暗。刀光剑影之间，是他对道义最坚定的守护。",
    tags: ["古装", "动作", "历史"],
    hot: 95,
  },
  {
    id: "m4",
    title: "深海救援",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20deep%20sea%20submarine%20surrounded%20by%20dark%20water%20and%20dramatic%20light%20rays%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-04&orientation=portrait",
    year: 2022,
    genres: ["动作", "灾难", "剧情"],
    region: "美国",
    rating: 7.9,
    duration: "132分钟",
    director: "詹姆斯·哈特",
    actors: ["汤姆·里德", "艾米丽·陈", "卡尔·李"],
    synopsis: "一艘科研潜艇在马里亚纳海沟深处失联，艇上载有六名科学家。一支经验丰富的救援小队临危受命，在氧气耗尽前潜入万米深渊。时间、压力与未知的深海生物，共同构成了这场惊心动魄的生死营救。",
    tags: ["深海", "灾难", "救援"],
    hot: 83,
  },
  {
    id: "m5",
    title: "时光信笺",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20young%20couple%20reading%20an%20old%20letter%20in%20golden%20sunset%20light%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-05&orientation=portrait",
    year: 2023,
    genres: ["爱情", "剧情", "奇幻"],
    region: "韩国",
    rating: 8.0,
    duration: "118分钟",
    director: "朴智勋",
    actors: ["金秀贤", "韩素希", "李到晛"],
    synopsis: "一间老旧的邮局里，放着一只能寄往过去的信箱。女主角偶然寄出的一封信，却改变了十年前那个夏天的一切。当回忆与当下交织，她终于明白，有些告别其实从未真正发生。",
    tags: ["爱情", "奇幻", "治愈"],
    hot: 79,
  },
  {
    id: "m6",
    title: "荒原猎手",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20rugged%20cowboy%20on%20horseback%20crossing%20a%20dusty%20desert%20canyon%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-06&orientation=portrait",
    year: 2021,
    genres: ["西部", "动作", "冒险"],
    region: "美国",
    rating: 7.6,
    duration: "121分钟",
    director: "罗伯特·凯恩",
    actors: ["杰克·莫里森", "露西·布莱尔", "汉克·韦德"],
    synopsis: "荒凉边境，一名沉默的赏金猎手受雇追捕一伙亡命之徒。穿越峡谷与荒漠的旅途中，他逐渐发现这场追捕背后隐藏着更深的阴谋。当正义与生存无法两全，他选择了自己的答案。",
    tags: ["西部", "冒险", "动作"],
    hot: 71,
  },
  {
    id: "m7",
    title: "城市之光",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20solitary%20figure%20walking%20through%20a%20foggy%20european%20city%20street%20at%20dawn%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-07&orientation=portrait",
    year: 2024,
    genres: ["剧情", "文艺"],
    region: "法国",
    rating: 8.3,
    duration: "112分钟",
    director: "让-吕克·贝尔",
    actors: ["索菲·马尔尚", "路易·加西亚", "安娜·杜邦"],
    synopsis: "一个在城市里漂泊的流浪画家，用画笔记录着他遇见的每一个陌生人。当他的画作意外走红，他却选择继续游走在清晨的街头。影片以细腻的镜头语言，讲述普通人身上微弱却温暖的光。",
    tags: ["剧情", "文艺", "治愈"],
    hot: 74,
  },
  {
    id: "m8",
    title: "无声证词",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20dramatic%20courtroom%20scene%20with%20a%20witness%20silhouette%20and%20strong%20lighting%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-08&orientation=portrait",
    year: 2023,
    genres: ["犯罪", "悬疑", "律政"],
    region: "中国大陆",
    rating: 8.1,
    duration: "127分钟",
    director: "孙铭",
    actors: ["张译", "谭卓", "王砚辉"],
    synopsis: "一桩看似铁证如山的命案，却因一位聋哑证人的出现而出现转机。年轻律师沈知远与时间赛跑，在有限的证据中寻找被忽略的真相。沉默，有时比呐喊更有力量。",
    tags: ["律政", "悬疑", "犯罪"],
    hot: 86,
  },
  {
    id: "m9",
    title: "龙脊护卫",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20martial%20artist%20leaping%20across%20mountain%20ridges%20with%20flowing%20silk%20robes%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-09&orientation=portrait",
    year: 2022,
    genres: ["武侠", "动作", "古装"],
    region: "中国大陆",
    rating: 7.8,
    duration: "135分钟",
    director: "徐皓峰",
    actors: ["张震", "倪妮", "此沙"],
    synopsis: "明末乱世，一支守护茶马古道的护卫队屡遭劫难。年轻护卫沈砚背负师门之托，沿龙脊山脉护送一批重要物资。刀锋所指，皆是人心；长路尽头，他守护的是心中的侠义。",
    tags: ["武侠", "古装", "动作"],
    hot: 76,
  },
  {
    id: "m10",
    title: "雾都疑影",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20mysterious%20figure%20in%20victorian%20london%20fog%20lit%20by%20gas%20lamps%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-10&orientation=portrait",
    year: 2024,
    genres: ["悬疑", "惊悚", "犯罪"],
    region: "英国",
    rating: 8.4,
    duration: "129分钟",
    director: "大卫·芬查",
    actors: ["汤姆·哈迪", "凯拉·奈特莉", "本尼迪克特"],
    synopsis: "十九世纪的伦敦，浓雾笼罩着泰晤士河畔。一位私家侦探受雇调查一系列诡异命案，每具尸体旁都留有相同的怀表。随着调查深入，他发现自己也早已被卷入这场精心设计的局中。",
    tags: ["悬疑", "惊悚", "古典"],
    hot: 88,
  },
  {
    id: "m11",
    title: "火星黎明",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20red%20martian%20landscape%20with%20a%20lone%20rover%20under%20a%20rising%20sun%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-11&orientation=portrait",
    year: 2025,
    genres: ["科幻", "冒险", "剧情"],
    region: "美国",
    rating: 8.6,
    duration: "142分钟",
    director: "丹尼斯·维伦纽瓦",
    actors: ["瑞恩·高斯林", "章子怡", "奥斯卡·伊萨克"],
    synopsis: "首批火星殖民者在红色荒原上建立起新的家园。当一场百年不遇的沙暴摧毁基地，幸存者们必须徒步穿越无人区抵达接应点。在人类最遥远的边疆，他们重新定义了“家”的含义。",
    tags: ["科幻", "火星", "冒险"],
    hot: 97,
  },
  {
    id: "m12",
    title: "欢乐厨房",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20cheerful%20chef%20tossing%20ingredients%20in%20a%20warm%20rustic%20kitchen%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-12&orientation=portrait",
    year: 2023,
    genres: ["喜剧", "家庭"],
    region: "中国大陆",
    rating: 7.4,
    duration: "106分钟",
    director: "闫非",
    actors: ["沈腾", "马丽", "常远"],
    synopsis: "一家濒临倒闭的老字号餐馆，迎来了三位性格迥异的新员工。为了保住这间承载着街坊回忆的小店，一群“不靠谱”的人开始了手忙脚乱的翻身计划。笑料百出之间，是热气腾腾的人间烟火。",
    tags: ["喜剧", "家庭", "美食"],
    hot: 68,
  },
  {
    id: "m13",
    title: "极地营救",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20still%20of%20a%20rescue%20team%20trekking%20across%20a%20snowstorm%20in%20the%20arctic%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-13&orientation=portrait",
    year: 2022,
    genres: ["动作", "冒险", "灾难"],
    region: "加拿大",
    rating: 7.7,
    duration: "115分钟",
    director: "彼得·泰特",
    actors: ["连姆·尼森", "艾丽西亚", "诺亚·泰勒"],
    synopsis: "一支极地科考站在暴风雪中与外界失联。经验丰富的向导带领救援小队深入冰原，在零下四十度的严寒里与时间赛跑。风雪掩埋了道路，却掩不住他们寻找同伴的决心。",
    tags: ["极地", "救援", "冒险"],
    hot: 70,
  },
  {
    id: "m14",
    title: "星月之约",
    category: "movie",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20anime%20movie%20poster%20still%20of%20a%20girl%20under%20a%20starry%20sky%20with%20glowing%20fireflies%2C%20cinematic%20lighting%20with%20warm%20orange%20rim%20highlights%20against%20a%20deep%20charcoal%20background%2C%20film%20grain%2C%20moody%20atmosphere%2C%20vertical%20poster%20composition%2C%20no%20text%2C%20highly%20detailed%20photography&width=600&height=900&seq=baihu-movie-14&orientation=portrait",
    year: 2024,
    genres: ["动画", "奇幻", "爱情"],
    region: "日本",
    rating: 8.2,
    duration: "111分钟",
    director: "新海诚",
    actors: ["神木隆之介", "上白石萌音", "花泽香菜"],
    synopsis: "每年夏夜，小镇上空都会出现一场奇异的星雨。少女铃音在森林深处遇见了一位来自星空的少年，两人约定共同寻找坠落的星辰。一段短暂却绚烂的夏天，就此展开。",
    tags: ["动画", "奇幻", "治愈"],
    hot: 84,
  },
];